import { Upload } from 'lucide-react'

import { AgentKind, AgentKindProvider } from '@/components/AgentChat/AgentKindProvider'
import { useAskCaiHandoff } from '@/components/AskCai/useAskCaiHandoff'
import { useCaiDocked } from '@/components/sidebar'
import { Button } from '@/components/ui/button'

/** Waits in the composer for the carrier to attach the files and send. */
export const SEND_DOCUMENTS_PROMPT =
  'I have compliance documents to file in my vault. I am attaching them here — please file each one to the right driver, vehicle or carrier and tell me what is still missing.'

function Inner() {
  const { prefill, isPending } = useAskCaiHandoff()
  return (
    <Button
      variant="outline"
      loading={isPending ? 'Opening…' : undefined}
      onClick={() => void prefill(SEND_DOCUMENTS_PROMPT)}
    >
      <Upload />
      Upload documents
    </Button>
  )
}

/** Opens Ask Cai with the ask already typed, so the carrier only has to attach the files and send. */
export function SendToCaiButton() {
  if (useCaiDocked()) return null
  return (
    <AgentKindProvider kind={AgentKind.ASK_CAI}>
      <Inner />
    </AgentKindProvider>
  )
}
